module.exports = {"items":{"home":"OMyFu","profile":"Profile","funeral":{"topLevel":"My Funeral","burial":"Burial","ceremony":"Farewell ceremony","guestlist":"Guest list","speeches":"Speeches & Addresses"},"guardians":{"topLevel":"Guardians","guardians":"My guardians","proteges":"I am a guardian","invitations":"Invitations"},"contacts":"Contacts","photos":"Photos","documents":"Documents","pets":"Pets","links":"Links","account":"Account","logout":"Log out","languageSwitcher":"EN"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/menu.json
// module id = CaMg
// module chunks = 1